module.exports = __webpack_public_path__ + "static/img/预约挂号@2x.05dc9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/预约挂号@2x.png
// module id = 320
// module chunks = 363 364